"use strict";

angular.module("admin")
	.directive("actionLogValue", [function () {
		return {
			restrict: "A",
			scope: {
				display: "<actionLogValue"
			},
			template: "<div ng-include=\"'actionLogValue.html'\"></div>"
		};
	}]);
